import { render, staticRenderFns } from "./builddevice.vue?vue&type=template&id=45495fca&scoped=true&"
import script from "./builddevice.vue?vue&type=script&lang=js&"
export * from "./builddevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45495fca",
  null
  
)

export default component.exports